import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { sortEntitiesByBusinessThenName } from "@components/entity/sortEntitiesByBusinessThenName";
import { Entity } from "@common/types/entity";
import { useMemo } from "react";
import { CaptureClicks } from "@design-system/CaptureClicks/CaptureClicks";
import { EntityAvatarGroup } from "@components/avatar/EntityAvatarGroup";
import { ClientDetailsRow } from "../clientViewConfig";
import { useGoToClientEntitySettings } from "../../useGoToClientEntitySettings";

export const EntitiesCell = ({
    getValue,
    row,
}: CellContext<ViewTableFeatures, ClientDetailsRow, Entity[]>) => {
    const workspace = row.getParentRow()?.original ?? row.original;
    const sortedEntities = useMemo(
        () => sortEntitiesByBusinessThenName(getValue() ?? []),
        [getValue],
    );

    const handleEntitySelected = useGoToClientEntitySettings();

    if (sortedEntities.length === 0) {
        return null;
    }

    return (
        <CaptureClicks>
            <EntityAvatarGroup
                entities={sortedEntities}
                max={5}
                size="sm"
                onEntityClick={(entity) =>
                    handleEntitySelected(workspace.id, entity.id)
                }
            />
        </CaptureClicks>
    );
};
